import React from 'react';
import Button from 'react-bootstrap/Button';

function HeadingRow(props){
  const { emptyCart } = props;
  return (
    <tr>
      <th>Stock No.</th>
      <th>Shape</th>
      <th>Ct.</th>
      <th>Color</th>
      <th>Clarity</th>
      <th>Lab</th>
      <th>Cut</th>
      <th>Polish</th>
      <th>Symmetry</th>
      <th>Flo.</th>
      <th>Depth&nbsp;%</th>
      <th>Table&nbsp;%</th>
      <th className="p-1">Measurements</th>
      <th>Ratio</th>
      <th>Price / Ct.</th>
      <th>Total Price</th>
      <th>Rap. Disc. %</th>
      <th>Status</th>
      <th>Pic.</th>
      <th>Vid.</th>
      <th>
        <Button
          className="py-0"
          variant="outline-danger"
          size="sm"
          title="empty cart"
          onClick={() => emptyCart('deleted')}
        >empty cart</Button>
      </th>
    </tr>
  );
}

export default HeadingRow;
